import { GameWorld, eGameObject as eWorldObject } from "../../../GameWorld";
import { RoadBase } from "./Road";
import { eType } from "../../Section";



export class Road1 extends RoadBase {
    private static readonly SIZE = 1;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super("road1", eType.road1, 1);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected addObjectEntities(): void {
        let e = GameWorld.instance.getObjectNewEntity(eWorldObject.road);
        e.setPosition(0, 0, 0);
        e.setLocalScale(1, 1, 0.5);
        e.reparent(this._root);
    }
}